/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbD0iaW5oZXJpdCIgZD0iTTEgNS4wMjlWNC4yN2g1LjI4NnYuNzU4SDQuMDd2Ni4yOWgtLjg1NFY1LjAzSDFaTTguNjc3IDJ2MTEuNTkxSDcuOTlWMmguNjg4Wk0xMC43NzQgMTEuMzJWNC4yN0gxNXYuNzU4aC0zLjM3M1Y3LjQxaDMuMDU2di43NTdoLTMuMDU2djMuMTUzaC0uODUzWiIvPg==";